// extracted by mini-css-extract-plugin
module.exports = {"card":"productcard-module--card--W0-bo"};